import React from 'react';

import { Link } from '../';

export const linkRenderer =
  (origin: 'global-header' | 'global-footer') => (props: any) =>
    (
      <Link
        {...props}
        skipResolvedUrl
        data-analytics-origin={origin}
        tracking={props['data-analytics']}
      />
    );
